import { render, staticRenderFns } from "./EmailVerify.vue?vue&type=template&id=61b1ef2a&scoped=true&"
import script from "./EmailVerify.vue?vue&type=script&lang=ts&"
export * from "./EmailVerify.vue?vue&type=script&lang=ts&"
import style0 from "./EmailVerify.vue?vue&type=style&index=0&id=61b1ef2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b1ef2a",
  null
  
)

export default component.exports